// src/App.js
import React from "react";
import { Resource, Admin } from "react-admin";

import { authProvider } from "./authProvider";
import dataProvider from "./common/restClient";
import Login from "./Login";

import { CategoriesList, CategoryCreate, CategoryEdit } from "./categories";
import CategoryIcon from "@mui/icons-material/Label";

import { ProductsList, ProductCreate, ProductEdit } from "./products";
import ProductIcon from "@mui/icons-material/ShoppingCart";

import { ClientsList, ClientEdit } from "./clients";
import ClientIcon from "@mui/icons-material/People";

import {
  ServiceRequestsList,
  ServiceRequestCreate,
  ServiceRequestEdit,
} from "./servicerequests";
import ServiceRequestsIcon from "@mui/icons-material/AlarmOn";

import polyglotI18nProvider from "ra-i18n-polyglot";
import spanishMessages from "aor-language-spanish";
import customSpanishMessages from "./common/i18n/es";

import {
  TechnicalServiceCreate,
  TechnicalServiceList,
  TechnicalServiceEdit,
} from "./technicalservice";

import { CreateSeller, EditSeller, ListSeller } from "./sellers";

import { CustomExtendedWarranty } from "./extendedwarranty";
import FileDownload from "@mui/icons-material/Download";

import { ROLES } from "./servicerequests/utils";

import { ArticlesList, ArticleCreate, ArticleEdit } from "./articles";
import ArticleIcon from "@mui/icons-material/Article";

import { BannersList, BannerCreate, BannerEdit } from "./banners";
import BannerIcon from "@mui/icons-material/ViewCarousel";

const messages = {
  es: {
    ...spanishMessages,
    ...customSpanishMessages,
  },
};

const i18nProvider = polyglotI18nProvider((locale) => messages[locale], "es");

const title = () =>
  localStorage.getItem("role") === ROLES.ADMIN
    ? "Winco"
    : `Hola, ${localStorage.getItem("email") || "Service Winco"}`;

const App = () => (
  <Admin
    authProvider={authProvider}
    dataProvider={dataProvider}
    loginPage={Login}
    title={title()}
    i18nProvider={i18nProvider}
  >
    {(permissions) => [
      // Servicio Técnico
      [ROLES.SERVICE_ADMIN, ROLES.ADMIN].includes(permissions) ? (
        <Resource
          name="services"
          list={TechnicalServiceList}
          create={TechnicalServiceCreate}
          edit={TechnicalServiceEdit}
          options={{ label: "Servicio Técnico" }}
        />
      ) : null,

      // Pedidos de Servicio
      <Resource
        name="servicerequests"
        list={ServiceRequestsList}
        create={permissions === ROLES.SERVICE ? ServiceRequestCreate : null}
        edit={
          [ROLES.SERVICE, ROLES.SERVICE_ADMIN, ROLES.ADMIN].includes(permissions)
            ? ServiceRequestEdit
            : null
        }
        icon={ServiceRequestsIcon}
        options={{ label: "Pedidos de Servicio Técnico" }}
      />,

      // Categorías - Solo admin
      permissions === ROLES.ADMIN ? (
        <Resource
          name="categories"
          list={CategoriesList}
          create={CategoryCreate}
          edit={CategoryEdit}
          icon={CategoryIcon}
          options={{ label: "Categorías" }}
        />
      ) : null,

      // Productos
      permissions === ROLES.ADMIN ? (
        <Resource
          name="products"
          list={ProductsList}
          create={ProductCreate}
          edit={ProductEdit}
          icon={ProductIcon}
          options={{ label: "Productos" }}
        />
      ) : (
        <Resource name="products" options={{ label: "Productos" }} />
      ),

      // Clientes - Solo admin
      permissions === ROLES.ADMIN ? (
        <Resource
          name="clients"
          list={ClientsList}
          edit={ClientEdit}
          icon={ClientIcon}
          options={{ label: "Clientes" }}
        />
      ) : null,

      // Provincias
      [ROLES.SERVICE_ADMIN, ROLES.ADMIN].includes(permissions) ? (
        <Resource name="provinces" options={{ label: "Provincias" }} />
      ) : null,

      // Puntos de Venta - Solo admin
      permissions === ROLES.ADMIN ? (
        <Resource
          name="sellers"
          create={CreateSeller}
          list={ListSeller}
          edit={EditSeller}
          options={{ label: "Puntos de Venta" }}
        />
      ) : null,

      // Garantía Extendida - Solo admin
      permissions === ROLES.ADMIN ? (
        <Resource
          name="extendedwarranty"
          list={CustomExtendedWarranty}
          icon={FileDownload}
          options={{ label: "Garantía Extendida" }}
        />
      ) : null,

      // Artículos del Blog - Solo admin
      permissions === ROLES.ADMIN ? (
        <Resource
          name="articles"
          list={ArticlesList}
          create={ArticleCreate}
          edit={ArticleEdit}
          icon={ArticleIcon}
          options={{ label: "Blog" }}
        />
      ) : null,

      // Banners - Solo admin
      permissions === ROLES.ADMIN ? (
        <Resource
          name="banners"
          list={BannersList}
          create={BannerCreate}
          edit={BannerEdit}
          icon={BannerIcon}
          options={{ label: "Banners" }}
        />
      ) : null,
    ]}
  </Admin>
);

export default App;